@if (showItb()) {
  <!-- Loading spinner -->
  @if (showLoading) {
    <loading-spinner></loading-spinner>
  } @else {
    <div class="bp-modal-body-upper pt-0 mb-0" [ngClass]="{ 'bp-modal-body-upper-success': isSuccessStep() }">
      <div class="info-box">
        <!-- Icon -->
        <span class="flex mr-10">
          <img
            [src]="getBest()?.getLogo()"
            [style.width.px]="20"
            (error)="img.src = getBest()?.getDefaultLogo()"
            alt="{{ 'logo_alt_text' | translate }}"
            #img />
        </span>
        @if (!isSaving) {
          <span class="font-size-13">
            <!-- Text -->
            {{ messageKey | translate }}
            <!-- Amount -->
            <strong>
              <span>
                {{
                itbAmount
                | tradable_precision_symbol
                : { id: getBest()?.getId(), addName: true, ignorePrecision: true }
                }}
              </span>
            </strong>
          </span>
        }
        @if (isSaving) {
          <span class="font-size-13">
            <!-- Text -->
            {{ "instant_trade_bonus_savings" | translate }}
            <!-- Amount -->
            <strong>
              <span>
                {{
                itbAmount
                | tradable_precision_symbol
                : { id: getBest()?.getId(), addName: true, ignorePrecision: true }
                }}
              </span>
            </strong>
            <!-- Text -->
            {{ "instant_trade_bonus_savings_end" | translate }}
          </span>
        }
      </div>
    </div>
  }
}
